module.exports = __webpack_public_path__ + "media/65.9d2b3ea0.wav";